import "./roleForm.css";
import { ROLE_OPTIONS, hasAdminAccess } from "../services/roles";
import { Input } from "reactstrap";
import PropTypes from "prop-types";
import { changeUserRole } from "../actions/users";
import { connect } from "react-redux";

const RoleForm = ({ userDetails, currentUser, onChangeUserRole }) => {
  function handleChangeRole(event) {
    event.preventDefault();
    onChangeUserRole(userDetails.id, event.target.value);
  }

  function renderRoleSelection() {
    return (
      <Input
        type="select"
        className="select-input-table"
        value={userDetails.role}
        disabled={currentUser.id === userDetails.id}
        onChange={handleChangeRole}
        aria-label="Change user role"
      >
        {ROLE_OPTIONS.map((role) => (
          <option key={role.label} value={role.value}>
            {role.label}
          </option>
        ))}
      </Input>
    );
  }

  return (
    <div>
      {hasAdminAccess(currentUser) ? renderRoleSelection() : userDetails.role}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    currentUser: state.user.self,
  };
}

const callbacks = {
  onChangeUserRole: changeUserRole,
};

export default connect(mapStateToProps, callbacks)(RoleForm);

RoleForm.propTypes = {
  currentUser: PropTypes.object.isRequired,
  userDetails: PropTypes.object.isRequired,
  onChangeUserRole: PropTypes.func.isRequired,
};
